import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BaseApiService {
  public baseUrl     = environment.apiUrl;
  public app_version = environment.app_version;

  constructor(
    public router: Router,
    public http: HttpClient,
  ) { }
}
